import SubmissionsView from 'broker/components/SubmissionsView';
import { SubmissionViewMode } from 'broker/components/SubmissionsView/utils';

export default function SubmissionsBoxPage() {
  return <SubmissionsView viewMode={SubmissionViewMode.PreviewBox} />;
}
